export const PlatformFeature = {
    name: 'accugps',
    text: {
        mapView: {
            addDevice: 'Add Device',
            showAllDevice: 'Show All Devices'
        }
    }
}
